module.exports = __webpack_public_path__ + "img/google-calendar.3858bb27.svg";